import React, { useEffect, useState } from 'react';
import './AlarmsLayout.scss';
import { NavLink, Route, Switch } from 'react-router-dom';
import { Card, CardBody, Col, FormFeedback, FormGroup, Label, Row } from 'reactstrap';
import PasswordInput from '../../components/Form/PasswordInput/PasswordInput';
import axios from 'axios';
import NetworkService from '../../utils/network.service';
import SnackbarUtils from '../../utils/SnackbarUtils';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/Store';
import { setLoginPostStatus } from '../../features/auth/auth.slice';
import { FETCH_STATUS } from '../../types/enums/fetch-status.enum';
import { AlarmsRoutes } from '../../routes/AlarmsRoutes';
import { setAccessToken } from '../../features/alarm/alarm.slice';
import { showApiErrorSnackbar } from '../../utils/api';

const AlarmsLayout = (): JSX.Element => {
  // STATE
  const [password, setPassword] = useState('');
  const [showError, setShowError] = useState(false);

  // REDUX
  const dispatch = useDispatch();
  const { accessToken } = useSelector((state: RootState) => state.alarmsReducer);

  const handleOnPasswordChange = e => {
    setPassword(e.target.value);
    if (showError) setShowError(false);
  };

  const checkPassword = () => {
    if (password) {
      dispatch(setLoginPostStatus(FETCH_STATUS.PENDING));
      axios
        .post(`${process.env.REACT_APP_API_URL}/auth/login/`, {
          username: 'alarms@telcloud.io',
          password: password,
        })
        .then(response => {
          dispatch(setLoginPostStatus(FETCH_STATUS.FULFILLED));
          localStorage.setItem('alarm-token', response.data.access_token);
          NetworkService.setupDefaultHeaders(response.data.access_token);
          dispatch(setAccessToken(response.data.access_token));
          SnackbarUtils.success('You\'re logged in!');
        })
        .catch(error => {
          dispatch(setLoginPostStatus(FETCH_STATUS.REJECTED));
          showApiErrorSnackbar({ error, fallback: 'Error during login!' });
        });
    }
  };

  useEffect(() => {
    const accessToken = localStorage.getItem('alarm-token') || null;
    if (accessToken) {
      NetworkService.setupDefaultHeaders(accessToken);
      dispatch(setAccessToken(accessToken));
    }
  }, [dispatch]);

  return (
    <main className={'alarm-container'}>
      <Row>
        <Col>
          <Card className={'mx-3 my-2'}>
            <CardBody>
              <NavLink
                className={'alarm-link'}
                to='/alarms'
                isActive={match => {
                  return !!match?.isExact;
                }}
              >
                Dashboard
              </NavLink>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {accessToken ? (
        <Switch>
          {AlarmsRoutes.map(
            (
              prop: {
                path: string;
                name: string;
                icon: string;
                component: React.ComponentType;
              },
              key
            ) => {
              return <Route path={prop.path} component={prop.component} key={key} />;
            }
          )}
        </Switch>
      ) : (
        <Row>
          <Col>
            <Card className={'mx-3 my-2'} style={{ minHeight: '80vh' }}>
              <CardBody className={'d-flex justify-content-center align-items-center h-100'}>
                <div className={'h-100'}>
                  <FormGroup>
                    <Label>Enter the password to view the content</Label>

                    <PasswordInput invalid={showError} onChange={handleOnPasswordChange} autoComplete='new-password' />
                    {showError && <FormFeedback>Wrong password</FormFeedback>}
                  </FormGroup>
                  <button type='button' className='btn btn-block btn-primary' onClick={checkPassword}>
                    Check password
                  </button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </main>
  );
};
export default AlarmsLayout;
